import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import * as styles from "./menus.css";
import { Menu } from "./components/Menu/Menu";
import lunchImage from "../../../../assets/Menus/menulunch2.jpg";
import dinnerImage from "../../../../assets/Menus/nightmuku.jpg";
import takeoutImage from "../../../../assets/Menus/menu04takeout.jpg";

const menuItems = [
  {
    title: "LUNCH",
    japaneseTitle: "ランチ",
    description: "癒しの空間で、ゆったりとしたランチタイムをお過ごしください",
    imageSrc: lunchImage,
  },
  {
    title: "DINNER",
    japaneseTitle: "夜ムク",
    description: "シェフお任せコースと厳選セレクトのお酒を大切な人たちとご堪能いただけます",
    imageSrc: dinnerImage,
  },
  {
    title: "TAKEOUT",
    japaneseTitle: "お持ち帰り",
    description: "お家でもKitchen Müküをお楽しみいただけます。ご家族との食事や、イベント、勉強会などのご利用に最適です",
    imageSrc: takeoutImage,
  },
];

export const Menus: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);
  const containerRef = useRef<HTMLElement>(null);
  const navigate = useNavigate();

  const handleMenuClick = (link: string) => {
    if (link === "TAKEOUT") {
      navigate('/takeoutmenu');
    } else if (link === "LUNCH") {
      navigate('/lunchmenu');
    } else if (link === "DINNER") {
      navigate('/dinnermenu');
    }
  };

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.unobserve(entry.target);
        }
      },
      {
        threshold: 0.1,
        rootMargin: "-50px",
      }
    );

    if (containerRef.current) {
      observer.observe(containerRef.current);
    }

    return () => {
      if (containerRef.current) {
        observer.unobserve(containerRef.current);
      }
    };
  }, []);

  return (
    <section ref={containerRef} className={styles.container} id="menu">
      <div className={`${styles.menusGrid} ${isVisible ? styles.animate : ""}`}>
        {menuItems.map((item) => (
          <Menu
            key={item.title}
            title={item.title}
            japaneseTitle={item.japaneseTitle}
            description={item.description}
            imageSrc={item.imageSrc}
            onClick={() => handleMenuClick(item.title)}
          />
        ))}
      </div>
    </section>
  );
};